import React from 'react';
import { Alert } from 'antd';
import { useLanguage } from '../../contexts/LanguageContext';
import ChatMessageList from './ChatMessageList';
import ChatMessageInput from './ChatMessageInput';

/**
 * 右側對話區：Admin 提示橫幅 + 訊息列表 + 輸入框。
 * adminHintKey / adminHintFallback 由呼叫端按節點類型傳入。
 */
const ChatConversationPanel = ({
  messages,
  activeSession,
  inputText,
  onInputChange,
  onSend,
  sending,
  visible = true,
  adminHintKey,
  adminHintFallback
}) => {
  const { t } = useLanguage();

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0, overflow: 'hidden' }}>
      <Alert
        type="info"
        showIcon
        banner
        message={
          (adminHintKey && t(adminHintKey)) ||
          adminHintFallback ||
          '此處發送的訊息為 admin 介入，不會寫入 ChatBot 對話歷史'
        }
        style={{ borderRadius: 0, flexShrink: 0 }}
      />

      <ChatMessageList
        messages={messages}
        activeSession={activeSession}
        visible={visible}
      />

      <ChatMessageInput
        value={inputText}
        onChange={onInputChange}
        onSend={onSend}
        sending={sending}
        disabled={!activeSession}
      />
    </div>
  );
};

export default ChatConversationPanel;
